<section class="container mobiledb-Container">
  <div class="d-flex alert-section mb-2" *ngIf="alertMessageShow">
    <div class="col-10 d-flex align-items-center">
      <img class="ml-2" src="../../../assets/icons/warning_red.png">
      <div class="col fs-14 seasonAlertMessage" [innerHTML]="alertMessage"></div>
    </div>
    <div class="col-2 alert-close-homepg">
      <p class="close-banner" (click)="toggleAlert()"></p>
    </div>
  </div>
  <section class="row">
    <ng-template #ProcessingModal let-modal>
      <div class="modal-body body-style-processing">
        <app-loader [data]="'processingRequest'" class="processing-loader"></app-loader>
      </div>
    </ng-template>
    <section class="col d-lg-flex d-md-flex p-0">
      <!-- ===================Left Part====================== -->
      <section class="col-sm-12 col-md-3 col-lg-3 col-xl-2 reservation-Summary-Section">
        <app-loader *ngIf="!seasonsList"></app-loader>
        <section class="active-season-container" *ngIf="!(hideAll | async)">
          <section class="" *ngFor="let item of seasonsList; let i=index">
            <p class="active-Season mb-2">
              {{item.code}} {{'selectVaccines.reservations'|cxTranslate}}
            </p>
            <a class="mb-2 ml-0 padding-left-10 seasonActive curPointer"
              *ngIf="(item?.shipNow == true) && (!item?.ordersList?.orders || item?.ordersList?.orders?.length == 0)"
              [ngClass]="(seasonSelected ==  item.code || item?.defaultSeason)? 'bgHighlight': ''"
              (click)="reserveNow(item.code)">{{'selectVaccines.order_doses_immediate' | cxTranslate}}</a>
            <a class="mb-2 ml-0 padding-left-10 seasonActive curPointer"
              *ngIf="(item?.shipNow == false) && (!item?.ordersList?.orders || item?.ordersList?.orders?.length == 0)"
              [ngClass]="(seasonSelected ==  item.code || item?.defaultSeason)? 'bgHighlight': ''"
              (click)="reserveNow(item.code)">{{'selectVaccines.Next_Season' | cxTranslate}}</a>
            <section class="" *ngIf="item?.ordersList?.orders?.length > 5">
              <ng-select [items]="item?.ordersList?.orders" placeholder="Select" bindLabel="fluOrderNumber"
                [multiple]="false" [clearable]="false" [(ngModel)]="item.selectedReservation"
                (change)="changeReservation(item.selectedReservation, item.code)"
                class="mb-4 w-100 reservation-history-dropdown">
                <ng-template ng-label-tmp ng-option-tmp let-item="item">
                  {{item.fluOrderNumber}}
                  <img *ngIf="item?.orderStatus == 'Confirmed'" src="../../../assets/icons/confirm.png"
                    title='Confirmed'>
                  <img *ngIf="item?.orderStatus == 'Partially confirmed' || item?.orderStatus == 'Partially Confirmed'"
                    src="../../../assets/icons/part-confirm.png" title='Partially confirmed'>
                  <img *ngIf="item?.orderStatus == 'Not confirmed' || item?.orderStatus == 'Not Confirmed'"
                    title='Not confirmed' src="../../../assets/icons/not-confirm.png">
                </ng-template>
              </ng-select>
            </section>
            <section class="row" *ngIf="item?.ordersList?.orders?.length<=5">
              <section class="col-12 col-xs-12 col-sm-12 col-lg-12"
                *ngFor="let data of item?.ordersList?.orders; let index = index">
                <div class="col pl-3 pt-1 pb-1 mb-1 wait_title curPointer"
                  [ngClass]="(data.fluOrderNumber == idofReservation)? 'bgHighlight' : ''"
                  (click)="changeReservation(data, item.code)"> {{data.fluOrderNumber}}
                  <img class="cursor-pointer" *ngIf="data?.orderStatus == 'Confirmed'"
                    src="../../../assets/icons/confirm.png" title="Confirmed">
                  <img class="cursor-pointer"
                    *ngIf="data?.orderStatus == 'Partially confirmed' || data?.orderStatus == 'Partially Confirmed'"
                    src="../../../assets/icons/part-confirm.png" title='Partially confirmed'>
                  <img class="cursor-pointer"
                    *ngIf="data?.orderStatus == 'Not confirmed' || data?.orderStatus == 'Not Confirmed'"
                    title='Not confirmed' src="../../../assets/icons/not-confirm.png">
                </div>
              </section>
            </section>
            <a class="mb-2 ml-0 padding-left-10 seasonActive curPointer"
              *ngIf="item?.shipNow && item?.ordersList?.orders?.length > 0 && item?.allShippedOrders==true"
              (click)="reserveNow(item?.code)">
              Order Doses for Immediate Shipment
            </a>
            <a class="mb-2 ml-0 padding-left-10 seasonActive curPointer"
              *ngIf="!item?.shipNow && item?.ordersList?.orders?.length > 0 && item?.allShippedOrders==true"
              (click)="reserveNow(item?.code)">
              Reserve Doses Now
            </a>
          </section>
        </section>
        <section class="container active-season-container" [ngClass]="{'topborder': !(hideAll | async)}">
          <!-- <div class="d-flex mt-1" *ngIf="getRuleStatusFlag(seasonSelected) && !(hideAll | async)"> -->
          <div class="d-flex mt-1" *ngIf="getRuleStatusFlag(seasonSelected) && !(hideAll | async)">
            <div><img class="locImg" src="assets/icons/{{baseSiteId}}/waitlistNew.png" width="21"></div>
            <div>
              <span class="wait_title curPointer" (click)="redirecttowaitlist()">Waitlist</span>
              <p class="unitdetails ml-0" (click)="redirecttowaitlist()">{{waitlistValue}} units</p>
            </div>
          </div>
          <div class="d-flex mt-1">
            <div *ngIf="getActiveLocator?.length>0"><img class="locImg" src="assets/icons/{{baseSiteId}}/location.svg"
                width="21"></div>
            <div class="wait_title_custom" *ngIf="getActiveLocator?.length>0">
              <span class="wait_title curPointer" *ngIf="accountDetails?.billingDisplay"
                (click)="redirecttoRR('locator')">Influenza vaccine locator</span>
              <span title="view" class="wait_title curPointer" *ngIf="!accountDetails?.billingDisplay"
                [ngbPopover]=tooltiptemplate1 placement="top" #s3="ngbPopover" triggers="manual"
                popoverClass="savedordermini-popover" (click)="togglePopover(s3, 'locator')">Influenza vaccine
                locator</span>
              <p class="unitdetails ml-0">{{isActiveYes}}</p>
            </div>
          </div>
          <!-- <div class="d-flex" *ngIf="!(hideAll | async)">
            <div><img class="waitlistIcon locImg" src="assets/icons/{{baseSiteId}}/location.svg" width="15"></div>
            <div>
              <span class="wait_title curPointer" (click)="redirecttoRR('locator')">Influenza vaccine locator</span>
              <p class="unitdetails ml-0">{{isActiveYes}}</p>
            </div>
          </div> -->
          <div class="d-flex">
            <div><img class="locImg" src="../../../assets/icons/{{baseSiteId}}/revert.png" width="15"></div>
            <div class="wait_title_custom">
              <span (click)="redirecttoRR('recurring')" *ngIf="accountDetails?.billingDisplay"
                class="wait_title curPointer" placement="top" tooltipClass="rh-status-tooltip">
                Recurring reservations</span>
              <span title="view" class="wait_title curPointer" *ngIf="!accountDetails?.billingDisplay"
                [ngbPopover]=tooltiptemplate placement="top" #s3="ngbPopover" triggers="manual"
                popoverClass="savedordermini-popover" (click)="togglePopover(s3, 'RR')">Recurring reservations</span>
              <p class="unitdetails ml-0">{{Enrolled}}</p>
            </div>
          </div>
          <!-- <div class="d-flex">
            <div><img class="locImg" src="../../../assets/icons/{{baseSiteId}}/revert.png" width="15"></div>
            <div>
              <span (click)="redirecttoRR('recurring')" class="wait_title curPointer">
                Recurring reservations</span>
              <p class="unitdetails ml-0">{{Enrolled}}</p>
            </div>
          </div> -->
        </section>
      </section>
      <!-- ===================Middle Part====================== -->
      <section class="col-sm-12 col-md-9 col-lg-9 col-xl-10 reserve-Div h-100"
        *ngIf="!(hideAll | async);else showNotAShiptoMessage">
        <section class="middle-Section-Header row ml-0 mr-0">
          <section class="col-12 col-sm-7 col-md-5 col-lg-5 col-xl-5" *ngIf="!idofReservation">
            <section>
              <span class="influenza-Vaccine-Span"
                *ngIf="!statusDisplay">{{'orderConfirmation.newReservation'|cxTranslate}}</span>
              <span class="influenza-Vaccine-Span"
                *ngIf="statusDisplay && statusDisplay != 'Confirmed'">{{'selectVaccines.reservation'|cxTranslate}}
                {{idofReservation}}</span>
            </section>
            <section>
              <span class="influenza-Vaccine-Active-Season-Span">{{seasonSelected}}
                {{'selectVaccines.season'|cxTranslate}}<span *ngIf="statusDisplay"> | {{statusDisplay}}</span>
                <img class="statusIconSize mb-1 cursor-pointer" *ngIf="statusDisplay && statusDisplay == 'Confirmed'"
                  title='Confirmed' src="../../../assets/icons/confirm.png" />
                <img class="statusIconSize mb-1 cursor-pointer" *ngIf="statusDisplay == 'Partially confirmed'"
                  title='Partially confirmed' src="../../../assets/icons/part-confirm.png" />
                <img class="statusIconSize mb-1 cursor-pointer"
                  *ngIf="statusDisplay && statusDisplay == 'Not confirmed'" title='Not confirmed'
                  src="../../../assets/icons/not-confirm.png" />
              </span>
            </section>
          </section>
          <section class="col-12 col-sm-6 col-md-4 col-lg-5 col-xl-5 p-0" *ngIf="idofReservation">
            <section>
              <section class="">
                <span class="influenza-Vaccine-Span">{{'selectVaccines.reservation'|cxTranslate}}
                  {{idofReservation}}</span>
              </section>
              <section class="">
                <span class="influenza-Vaccine-Active-Season-Span">{{seasonSelected}}
                  {{'selectVaccines.season'|cxTranslate}} |
                  {{statusDisplay}}
                  <img class="statusIconSize mb-1 cursor-pointer" *ngIf="statusDisplay && statusDisplay == 'Confirmed'"
                    title='Confirmed' src="../../../assets/icons/confirm.png" />
                  <img class="statusIconSize mb-1 cursor-pointer" *ngIf="statusDisplay == 'Partially confirmed'"
                    title='Partially confirmed' src="../../../assets/icons/part-confirm.png" />
                  <img class="statusIconSize mb-1 cursor-pointer"
                    *ngIf="statusDisplay && statusDisplay == 'Not confirmed'" title='Not confirmed'
                    src="../../../assets/icons/not-confirm.png" />
                </span>
              </section>
            </section>
          </section>
          <section class="col-12 col-sm-6 col-md-8 col-lg-7 col-xl-7 iphone-Center d-flex justify-content-end"
            *ngIf="idofReservation && statusDisplay">
            <div class="row">
              <div class="col width-fit-content" *ngIf="statusDisplay == 'Confirmed' && showEditCTAShip">
                <button class="btn-primary editRes btn-small-reserve" (click)="viewReservation('EDIT')"
                  [hidden]="userReceivingHours">
                  {{'orderConfirmation.viewEditResDetails'|cxTranslate}}
                </button>
              </div>
              <div class="col view-btn width-fit-content"
                *ngIf="statusDisplay == 'Confirmed' || statusDisplay == 'Shipped'">
                <button class="btn-primary pl-4 pr-4 btn-small-reserve" (click)="viewReservation('VIEW')">
                  {{'orderConfirmation.viewResDetails'|cxTranslate}}
                </button>
              </div>
            </div>
          </section>
        </section>
        <section class="noReserve-Middle-Section-Content">
          <section class="plpbutton btn-align">
            <button class="btn-primary" (click)="reserveNow(seasonSelected)" *ngIf="!statusDisplay">
              {{'selectVaccines.reserveDoses'|cxTranslate}} {{seasonSelected}}
            </button>
          </section>
          <section class="flupara" [innerHTML]="fluParagraph"
            *ngIf="statusDisplay == 'Partially confirmed' || statusDisplay == 'Not confirmed' || !statusDisplay">
          </section>
          <section class="plpbutton btn-align"
            *ngIf="statusDisplay == 'Not confirmed' || statusDisplay == 'Partially confirmed'">
            <!-- <button class="btn-primary pl-4 pr-4 plpbutton btn-line-height" (click)="viewReservation('EDIT')"
              [hidden]="userReceivingHours || !fluParagraph"> -->
            <!--Not sure if there is any requirement of hiding the confirm now button itself in case "Not confirmed/Partially confirmed" text is not available in api-->
            <button class="btn-primary pl-4 pr-4 plpbutton btn-line-height" (click)="viewReservation('EDIT')"
              [hidden]="userReceivingHours">
              {{'selectVaccines.confirmNow'|cxTranslate}}
            </button>
          </section>
          <section *ngIf="statusDisplay === 'Confirmed' || statusDisplay === 'Shipped'">
            <!-- <section class="myShipmnets-Section" >
          <h3 class="myShipment">{{'orderConfirmation.myShipments'|cxTranslate}}</h3>
        </section> -->
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p0">
                <h3 class="title-new-myshipments">
                  <span>{{'orderConfirmation.myShipments'|cxTranslate}}</span>
                </h3>
                <button type="button" *ngIf="isShippingScheduleEnabled()" (click)="viewReservation('scheduleShipments')"
                  class="btn-secondary hidden-xs shipping-schedule-dash float-right">
                  Schedule Shipments</button>
              </div>
            </div>
            <!--Below input and output only valid and used for STS-shipped case-->
            <app-flu-charts [orderStatusDisplay]="statusDisplay" [stsFlag]="getStsFlag(seasonSelected)"
              [flupara]="fluparaStsShipped" (manageSts)="manageSts($event)"></app-flu-charts>
          </section>
        </section>

      </section>
      <ng-template #showNotAShiptoMessage>
        <div class="notValid">
          Please note, this account does not appear to have a valid shipping location on file. If you find this message
          in error, contact us on-line through Customer Support or call <span *ngIf="baseSiteId == 'vsh'">1-800-VACCINE
            (1-800-822-2463)</span><span *ngIf="baseSiteId == 'vax'">1-800-752-9338</span>, Monday through Friday 8:30
          AM - 6:00 PM (ET).
        </div>
      </ng-template>
      <ng-template #tooltiptemplate>
        <div class="row">
          <div class="col-12">
            <p class="active-Season">Recurring Reservation</p>
            <p class="tooltip_para">Include your practice locations in recurring reservations. The same influenza
              vaccines
              will be reserved automatically each year, and you'll simply have to confirm or edit the reservation.
              Manage
              enrollment and contact information at any time.
            </p>
            <hr />
          </div>
        </div>

        <div class="row">
          <div class="col-md-1"><img class="waitlistIcon locImg" src="assets/icons/{{baseSiteId}}/location.svg"
              width="15"></div>
          <div class="col-md-10"><span class="active-Season mb-2"> Reservation contact </span>
            <p *ngIf="!editMode">{{ordersList[0].firstName}} {{ordersList[0].lastName}}</p>
            <p *ngIf="editMode"><input class="texttype" type="text" #resContact [(ngModel)]="ordersList[0].fullName"
                onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32))'
                (keyup)="nameValidation(resContact.value)" name="servation_contact"><br />

              <span class="redmsgFax" *ngIf="nameErrorMsg">This field is required</span>
            </p>
            <span class="active-Season mb-2"> Preferred Contact Method </span>
            <p *ngIf="!editMode">{{ordersList[0].contactMethod=='INT'?'Email':'Fax'}} :
              {{ordersList[0].contactMethod=='INT'?ordersList[0].email:ordersList[0].fax}}</p>
            <p class="locationTitle" *ngIf="editMode">Email :<br />

              <input type="radio" class="checkmark" id="radio-btn" class="radioChecked" name="orderConfirmation1"
                (click)="cMethodElection('INT',emailVal.value)" value="INT" [(ngModel)]="ordersList[0].contactMethod" />

              &nbsp;<span class="emailField"><input #emailVal class="texttype2"
                  (keyup)="validateEmailmethod(emailVal.value)" type="email" [(ngModel)]="ordersList[0].email"
                  name="servation_contact"></span><br />
              <span class="redmsgFax" *ngIf="emailErrorMsg">This field is required</span>
              <span class="redmsgFax" *ngIf="!emailErrorMsg && mailErrorMsg">Please enter the valid email address</span>

            </p>
            <p class="locationTitle" *ngIf="ordersList[0]?.disableFax && editMode">Fax:<br />
              <input type="radio" class="checkmark" (click)="cMethodElection('fax',faxnumber.value)" id="radio-btn"
                name="orderConfirmation1" value="email" *ngIf="ordersList[0].contactMethod!='INT'" checked />

              <input type="radio" id="radio-btn" (click)="cMethodElection('fax',faxnumber.value)"
                name="orderConfirmation1" value="email" *ngIf="ordersList[0].contactMethod=='INT'" />

              &nbsp;<input #faxnumber class="texttype2"
                onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                type="text" (keyup)="validateFaxNumber(faxnumber.value,'fax',ordersList[0].fluContactId)"
                [(ngModel)]="ordersList[0].fax" name="servation_contact" /><br />
              <span class="redmsgFax" *ngIf="faxErrorMsg">This field is required</span>
            </p>
          </div>
          <div class="col-md-1 editLink" (click)="editModeOn()" *ngIf="!editMode"><img class="editIcon"
              src="../assets/icons/{{baseSiteId}}/editIcon.png" alt="icon">Edit</div>
          <div class="col-md-1 editLink2" *ngIf="editMode"><img class="editIcon" src="../assets/icons/edit_disable.svg"
              alt="icon">Edit</div>
        </div>

        <div class="row">
          <div class="col-md-1">&nbsp;</div>
          <div class="col-md-10 greybg">
            <span class="active-Season mb-2"> Status </span><br />
            <span class="loc_stat loc-switch">

              <label class="switch">
                <input type="checkbox" class="imCheck" (click)="changeEnrollFlag(ordersList[0]?.fluContactId,false)"
                  *ngIf="ordersList[0].enrollflag" checked>
                <input type="checkbox" class="imCheck" (click)="changeEnrollFlag(ordersList[0]?.fluContactId,true)"
                  *ngIf="!ordersList[0].enrollflag">

                <span class="slider round"></span>

              </label>
              <span *ngIf="ordersList[0].enrollflag">Enrolled </span>
              <span *ngIf="!ordersList[0].enrollflag">Not Enrolled</span>

            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-1">&nbsp;</div>
          <div class="col-md-10 tpmrgn">
            <p>
              <!-- {{phoneErrorMsg}}-{{faxErrorMsg}}-{{emailErrorMsg2}}-{{nameErrorMsg}} -->
              <button (click)="cancelEditSection()" class="btn-secondary mr-1">
                Cancel</button>

              <button *ngIf="faxErrorMsg || emailErrorMsg || nameErrorMsg || mailErrorMsg" (click)="SaveAction()"
                class="btn-primary" disabled>
                &nbsp;Save&nbsp;</button>

              <button *ngIf="!faxErrorMsg && !emailErrorMsg && !nameErrorMsg && !mailErrorMsg" (click)="SaveAction()"
                class="btn-primary">
                &nbsp;Save&nbsp;</button>
            </p>
          </div>
        </div>

      </ng-template>


      <ng-template #tooltiptemplate1>
        <div class="row">
          <div class="col-12">
            <p class="active-Season">Influenza vaccine locator</p>
            <p class="tooltip_para">flu locator alert message displayed here
            </p>
            <hr />
          </div>
        </div>

        <div class="row">
          <div class="col-md-1"><img *ngIf="!editMode" class="waitlistIcon locImg"
              src="assets/icons/{{baseSiteId}}/location.svg" width="15"></div>
          <div class="col-md-10">
            <!-- <span class="active-Season mb-2"> Reservation contact </span> -->
            <p *ngIf="!editMode">{{getActiveLocator[0].customerName}} <br> {{getActiveLocator[0].city}}
              {{getActiveLocator[0].address}}<br />{{getActiveLocator[0].state}} {{getActiveLocator[0].zipcode}} </p>
            <div *ngIf="editMode">

              <div class="row mg">
                <div class="col-6"><span class="active-Season mb-2"> Location Name </span></div>
                <div class="col-6"><span class="active-Season mb-2 ml-4"> Account # </span></div>
              </div>

              <div class="row mg">
                <div class="col-6"><input class="texttype1" type="text" #locName
                    [(ngModel)]="getActiveLocator[0].customerName"
                    onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32))'
                    (keyup)="nameValidation(locName.value,'name')" name="servation_contact">
                  <span class="redmsgFax" *ngIf="nameErrorMsg">This field is required</span>
                </div>
                <div class="col-6"><input disabled class="texttype1" type="text" #account
                    [(ngModel)]="getActiveLocator[0].operId"
                    onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32))'
                    name="servation_contact"></div>
              </div>

              <div class="row mg">
                <div class="col-6"><span class="active-Season mb-2"> Address </span></div>
                <div class="col-6"><span class="active-Season mb-2"> Phone </span></div>
              </div>

              <div class="row mg">
                <div class="col-6"><input class="texttype1" type="text" #address
                    [(ngModel)]="getActiveLocator[0].address"
                    onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32))'
                    (keyup)="nameValidation(address.value,'address')" name="servation_contact">
                  <span class="redmsgFax" *ngIf="addressErrorMsg">This field is required</span>
                </div>
                <div class="col-6"><input class="texttype" type="text" #phone [(ngModel)]="getActiveLocator[0].phone"
                    onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                    (keyup)="validateFaxNumber_locator(phone.value, 'phone', getActiveLocator[0].operId)"
                    name="servation_contact"><br />
                  <span class="redmsgFax" *ngIf="phoneErrorMsg">This field is required</span>
                </div>
              </div>

              <div class="row mg">
                <div class="col-4"><span class="active-Season mb-2"> City </span></div>
                <div class="col-4"><span class="active-Season mb-2"> State </span></div>
                <div class="col-4"><span class="active-Season mb-2"> Zip Code </span></div>
              </div>

              <div class="row mg">
                <div class="col-4"><input class="texttype" type="text" #city [(ngModel)]="getActiveLocator[0].city"
                    onkeypress='return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32))'
                    (keyup)="nameValidation(city.value,'city')" name="servation_contact">

                </div>
                <div class="col-4">

                  <ng-select class="statedrp" [items]="statesArr" bindLabel="isocode" [clearable]="false"
                    placeholder="Please select" [(ngModel)]="getActiveLocator[0].state" name="state">
                  </ng-select>

                </div>

                <div class="col-4"><input class="texttype" type="text" #zipCode
                    [(ngModel)]="getActiveLocator[0].zipcode"
                    onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                    maxlength="5" (keyup)="numberValidation(zipCode.value,'zip')" name="servation_contact">

                </div>
              </div>

              <div class="row mg">
                <div class="col-5"><span class="redmsgFax" *ngIf="cityErrorMsg">This field is required</span></div>
                <div class="col-2">&nbsp;</div>
                <div class="col-5"><span class="redmsgFax" *ngIf="zipErrorMsg">This field is required</span></div>
              </div>


              <!-- <span class="redmsgFax" *ngIf="nameErrorMsg">This field is required</span> -->
            </div>

          </div>
          <div class="col-md-1 editLink" (click)="editModeOn()" *ngIf="!editMode"><img class="editIcon"
              src="../assets/icons/{{baseSiteId}}/editIcon.png" alt="icon">Edit</div>
          <div class="col-md-1 editLink2" *ngIf="editMode"><img class="editIcon" src="../assets/icons/edit_disable.svg"
              alt="icon">Edit</div>
        </div>

        <div class="row">
          <div class="col-md-1">&nbsp;</div>
          <div class="col-md-10 greybg">

            <div class="row">
              <div class="col-md-4">
                <p class="active-Season mb-2"> Status </p>
              </div>

              <div class="col-md-4 p-0">
                <!-- <p class="active-Season mb-2"> {{getActiveLocator[0].fluBlockProductId}} </p> -->
                <p class="active-Season mb-2" [innerHTML]="getActiveLocator[0]?.fluBlockProductName">
                  <!-- {{getActiveLocator[0].hasOwnProperty(fluBlockProductName)?getActiveLocator[0].fluBlockProductName:getActiveLocator[0].fluBlockProductId}} -->
                  <!-- {{getActiveLocator[0]?.fluBlockProductName}} -->
                </p>
              </div>
              <div class="col-md-4 p-0">
                <!-- <p class="active-Season mb-2"> {{getActiveLocator[0].fluZoneProductId}} </p> -->
                <p class="active-Season mb-2" [innerHTML]="getActiveLocator[0]?.fluZoneProductName">
                  <!-- {{getActiveLocator[0].hasOwnProperty(fluZoneProductName)?getActiveLocator[0].fluZoneProductName:getActiveLocator[0].fluZoneProductId
                  }}  -->
                  <!-- {{getActiveLocator[0]?.fluZoneProductName}} -->
                </p>
              </div>
            </div>


            <div class="row">
              <div class="col-md-4">
                <p><span class="loc_stat loc-switch">
                    <label class="switch">
                      <input type="checkbox" class="imCheck"
                        (click)="changeEnrollFlag_locator(getActiveLocator[0]?.operId,false, 'status')"
                        *ngIf="getActiveLocator[0].statusId!=2" checked>
                      <input type="checkbox" class="imCheck"
                        (click)="changeEnrollFlag_locator(getActiveLocator[0]?.operId,true, 'status')"
                        *ngIf="getActiveLocator[0].statusId==2">

                      <span class="slider round"></span>

                    </label>
                    <span *ngIf="getActiveLocator[0].statusId!=2">Active </span>
                    <span *ngIf="getActiveLocator[0].statusId==2">Inactive</span>

                  </span></p>
              </div>

              <div class="col-md-4 p-0">
                <p><span class="loc_stat loc-switch">

                    <label class="switch">
                      <input type="checkbox" class="imCheck"
                        (click)="changeEnrollFlag_locator(getActiveLocator[0].fluBlockProductId,false, 'fluBlok')"
                        *ngIf="getActiveLocator[0].fluBlockOptedIn=='Offered'" checked>
                      <input type="checkbox" class="imCheck"
                        (click)="changeEnrollFlag_locator(getActiveLocator[0].fluBlockProductId,true, 'fluBlok')"
                        *ngIf="getActiveLocator[0].fluBlockOptedIn!='Offered'">

                      <span class="slider round"></span>

                    </label>
                    <span *ngIf="getActiveLocator[0].fluBlockOptedIn=='Offered'">Offered </span>
                    <span *ngIf="getActiveLocator[0].fluBlockOptedIn!='Offered'">Not Offered</span>

                  </span></p>
              </div>
              <div class="col-md-4 p-0">
                <p><span class="loc_stat loc-switch">
                    <label class="switch">
                      <input type="checkbox" class="imCheck"
                        (click)="changeEnrollFlag_locator(getActiveLocator[0]?.fluZoneProductId,false,'fluzone')"
                        *ngIf="getActiveLocator[0].fluZoneOptedIn=='Offered'" checked>
                      <input type="checkbox" class="imCheck"
                        (click)="changeEnrollFlag_locator(getActiveLocator[0]?.fluZoneProductId,true,'fluzone')"
                        *ngIf="getActiveLocator[0].fluZoneOptedIn!='Offered'">
                      <span class="slider round"></span>

                    </label>
                    <span *ngIf="getActiveLocator[0].fluZoneOptedIn=='Offered'">Offered </span>
                    <span *ngIf="getActiveLocator[0].fluZoneOptedIn!='Offered'">Not Offered</span>


                  </span></p>
              </div>
            </div>



          </div>
        </div>

        <div class="row">
          <div class="col-md-1">&nbsp;</div>
          <div class="col-md-10 tpmrgn">
            <p>
              <!-- {{phoneErrorMsg}}-{{faxErrorMsg}}-{{emailErrorMsg2}}-{{nameErrorMsg}} -->
              <button (click)="cancelEditSection()" class="btn-secondary mr-1">
                Cancel</button>

              <button *ngIf="cityErrorMsg || zipErrorMsg || phoneErrorMsg || addressErrorMsg || nameErrorMsg"
                (click)="SaveAction_locator()" class="btn-primary" disabled>
                &nbsp;Save&nbsp;</button>

              <button *ngIf="!cityErrorMsg && !zipErrorMsg && !phoneErrorMsg && !addressErrorMsg && !nameErrorMsg"
                (click)="SaveAction_locator()" class="btn-primary">
                &nbsp;Save&nbsp;</button>
            </p>
          </div>
        </div>
      </ng-template>
    </section>
    <!-- ==============================Footer Part============================ -->

    <section class="col-lg-12 col-xl-12 footer-Container">
      <!-- <app-influenza-dashbaord-footer [reserveNowClicked]="reserveNowClicked"
        (newItemEvent)="proceedToCategory($event)">
      </app-influenza-dashbaord-footer> -->
    </section>